<template>
  <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
    <template #trigger>
      <button class="button is-light" slot="trigger">
        {{ `${payments.currencySymbol}${formatMoney(cart.totalValue)}` }}
      </button>
    </template>

    <b-dropdown-item
      v-if="show"
      aria-role="listitem"
      v-for="item in cart.items"
      :key="item._id"
    >
      <p>
        {{
          item.scaleProduct && item.unit === "un"
            ? `${item.quantity} x ${payments.currencySymbol}${formatMoney(
                item.price
              )} - ${item.name}`
            : item.scaleProduct
            ? `1 x ${payments.currencySymbol}${formatMoney(item.itemPrice)} - ${
                item.name
              } ${item.quantity}g`
            : `${item.quantity} x ${payments.currencySymbol}${formatMoney(
                item.price
              )} - ${item.name}`
        }}
      </p>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "../../../mixins/mask";

export default {
  props: ["cart", "show"],

  mixins: [mask],

  computed: {
    ...mapGetters(["payments"])
  }
};
</script>
